import {useHttp} from "./http.hook";
import {IRatingUser, IToOrder, IToOrderFromMySignal, IUser} from "../shared/types";

interface IDataGetAllUsers {
  message: string,
  info: IUser[]
}

interface IDataGetOneUser {
  message: string,
  info: IUser
}

export const useUser = () => {

  const {loading, request, error, clearError} = useHttp()

  //получение полного списка пользователей сервиса
  const getUsers = async () => {
    try {
      const data: IDataGetAllUsers = await request('/api/users/get-users', 'GET')
      return data
    } catch (e) {
      throw e
    }
  }

  //получение имени пользователя и его роли из БД по его ID
  const getUser = async (userId: string) => {
    try {
      const data: IDataGetOneUser = await request('/api/users/get-user', 'POST', {
        userId: userId,
      })
      return data
    } catch (e) {
      throw e
    }
  }

  return {
    loading,
    getUsers,
    getUser,
    error,
    clearError
  }
}